// extracted by mini-css-extract-plugin
export default {"card-wrapper":"cards_card-wrapper__OAFpv"};